import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@shared-environments/environment';
import { HttpService } from '../http.service';

@Injectable()
export class ProductService {

  private getUrl = '/product/list';
  private getWhiteLabelItemsUrl = '/product/white-label-list';
  private getResellItemsUrl = '/product/resell-list';
  private getMyProductsUrl = '/product/list/user';
  private getOffersUrl = '/product/list/offer';
  private addUrl = '/product';
  private getProductUrl = '/product/:id';
  private getProductServiceUrl = '/product/service/:id';
  private getOfferUrl = '/product/:id/get-offer';
  private updateStatusUrl = '/product/updateStatus/:id';
  private initialInfoUrl = '/product/initialInfo';
  private updateSortingDateUrl = '/product/updateSortingDate/:id';
  private searchUrl = '/product/search';
  private copyUrl = '/product/copy/:id';

  ////
  // ****************** Stickers **************** //
  private getStickerProductUrl = '/product/stickerProduct';
  private updateStickerProductStatusUrl = '/product/stickerProduct/updateStatus';
  private addStickerUrl = '/product/stickerProduct/addSticker';
  private deleteStickerUrl = '/product/service/:id';
  private testDonationNotificationUrl = '/donationNotification/test/:id';
  private testStickerUrl = '/product/test';


  constructor(private networkHelper: HttpService) {
  }

  add(data: any): Observable<any> {
    return this.networkHelper.post(environment.apiURL +
      this.addUrl, data);
  }

  testSicker(data: any): Observable<any> {
    return this.networkHelper.post(environment.apiURL +
        this.testStickerUrl, data);
  }

  testNotification(id: any, data: any): Observable<any> {
    return this.networkHelper.post(environment.apiURL +
        this.testDonationNotificationUrl.replace(':id', id), data);
  }

  getItems(pagination: any, filter: any): Observable<any> {
    return this.networkHelper.get(environment.apiURL + this.getUrl, { ...pagination, ...filter });
  }
  getWhiteLabelItems(pagination: any, filter: any): Observable<any> {
    return this.networkHelper.get(environment.apiURL + this.getWhiteLabelItemsUrl, { ...pagination, ...filter });
  }

  getResellItems(pagination: any, filter: any): Observable<any> {
    return this.networkHelper.get(environment.apiURL + this.getResellItemsUrl, { ...pagination, ...filter });
  }

  getById(id: any): Observable<any> {
    return this.networkHelper.getWithSSR(environment.apiURL +
      this.getProductUrl.replace(':id', id));
  }
  initialInfo(params: any): Observable<any> {
    return this.networkHelper.get(environment.apiURL +
      this.initialInfoUrl, params);
  }
  update(id: any,data:any): Observable<any> {
    return this.networkHelper.put(environment.apiURL +
      this.getProductUrl.replace(':id', id), data);
  }
  updateStatus(id: any,data:any): Observable<any> {
    return this.networkHelper.put(environment.apiURL +
      this.updateStatusUrl.replace(':id', id), data);
  }
  getMyProducts(pagination: any, filter: any): Observable<any> {
    return this.networkHelper.get(environment.apiURL + this.getMyProductsUrl, { ...pagination, ...filter });
  }
  updateSortingDate(id: any): Observable<any> {
    return this.networkHelper.put(environment.apiURL +
      this.updateSortingDateUrl.replace(':id', id),{});
  }

  delete(id: any): Observable<any> {
    return this.networkHelper.del(environment.apiURL +
      this.getProductUrl.replace(':id', id));
  }

  getOffers(pagination: any, filter: any): Observable<any> {
    return this.networkHelper.get(environment.apiURL + this.getOffersUrl, { ...pagination, ...filter });
  }

  getOffer(id: string):Observable<any> {
    return this.networkHelper.post(environment.apiURL +
        this.getOfferUrl.replace(':id', id), {})
  }

  getStickersProduct(data: any = {}): Observable<any> {
    return this.networkHelper.get(environment.apiURL + this.getStickerProductUrl, data);
  }

  updateStickerProductStatus(updateData: any): Observable<any> {
    return this.networkHelper.put(environment.apiURL + this.updateStickerProductStatusUrl, {...updateData});
  }

  addSticker(data: any): Observable<any> {
    return this.networkHelper.put(environment.apiURL + this.addStickerUrl, {...data});
  }

  updateService(serviceId: string, data: any){
    return this.networkHelper.put(environment.apiURL + this.getProductServiceUrl.replace(':id', serviceId), {...data});
  }

  deleteService(serviceId: string): Observable<any> {
    return this.networkHelper.del(environment.apiURL +
        this.deleteStickerUrl.replace(':id', serviceId));
  }

  getServiceById(id: string): Observable<any> {
    return this.networkHelper.get(environment.apiURL +
        this.getProductServiceUrl.replace(':id', id));
  }
}
